import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const TermsAndCondition = () => {

   return (<>

      {/* <ComponenetHeader
         name={'Terms & Condition'}
      /> */}

      <section className="content_page text-left">
         <div className="container">
            <div className="row content_page_style justify-content-center">
               <div className="col-md-12">
                  <h2 className="mb-4">Terms and Conditions</h2>

                  <p>
                     Please read these Terms and Conditions ("Terms") carefully before accessing or using the Towing 411 website, mobile site, or applications (collectively, the "Service"). The Service is operated by Towing 411 ("we," "us," "our," or "the Company"). By accessing or using the Service, you agree to comply with and be legally bound by these Terms, which apply to all visitors, users, and others who access the Service.
                  </p>

                  <p>
                     If you do not agree with any part of these Terms, you must discontinue use of the Service immediately. Towing 411 reserves the right to modify or update these Terms at any time without prior notice. Continued use of the Service following changes constitutes acceptance of the revised Terms, which become effective upon posting.
                  </p>

                  <h3>Service Description</h3>
                  <p>
                     Towing 411 provides online advertising, listing, and marketing services for towing companies, roadside assistance providers, repair facilities, and trucking-related businesses across the United States. The Service enables users to access an online directory of service providers ("Advertisers") through the Towing 411 platform. Users are responsible for obtaining internet access and compatible devices, along with any related costs.
                  </p>

                  <h3>User Accounts</h3>
                  <p>
                     When you create an account, you are responsible for maintaining the confidentiality of your login credentials and for all activities conducted under your account. Any unauthorized access or use must be reported to Towing 411 immediately. Accounts are intended for individual use only and may not be sold, transferred, or used for commercial purposes without written authorization from Towing 411.
                  </p>

                  <h3>Vendor Information Disclaimer</h3>
                  <p>
                     Information displayed on the platform may be provided by Advertisers or obtained from publicly available sources. While Towing 411 makes reasonable efforts to maintain accurate listings, we do not warrant the completeness, accuracy, or reliability of such information. Users acknowledge and accept all risks associated with relying on vendor-provided content.
                  </p>

                  <h4>Service Changes and Interruptions</h4>
                  <p>
                     Towing 411 reserves the right to modify, suspend, or discontinue any part of the Service at any time without notice. We shall not be held liable for service interruptions, delays, or failures caused by factors beyond our reasonable control.
                  </p>

                  <h4>Privacy</h4>
                  <p>
                     Your use of the Service is governed by the Towing 411 Privacy Policy. Links to third-party websites or services are provided for convenience only and are subject to their own terms and privacy policies. Towing 411 does not control and is not responsible for third-party content, services, or availability.
                  </p>

                  <h4>Prohibited Activities</h4>
                  <p>
                     Users must use the Towing 411 platform in compliance with these Terms and applicable laws. Prohibited actions include, but are not limited to, copying or scraping content, misusing the platform for competitive purposes, submitting false information, or engaging in fraudulent, abusive, or harmful behavior. Violations may result in immediate account suspension, termination, or legal action.
                  </p>

                  <h4>User Information</h4>
                  <p>
                     By using the Service, you may submit personal or business information, which may be shared with Advertisers to fulfill service requests. By providing your information, you consent to being contacted by Towing 411 and its partners via phone, SMS, email, or other communication methods. You agree to provide accurate and up-to-date information. Submission of false or misleading data may result in account termination or legal consequences.
                  </p>

                  <h5>Intellectual Property</h5>
                  <p>
                     All content, software, logos, and platform materials are the property of Towing 411 or its licensors and are protected by applicable intellectual property laws. Unauthorized use, reproduction, modification, or distribution is strictly prohibited. Third-party trademarks remain the property of their respective owners.
                  </p>

                  <h5>Copyright Infringement Notification</h5>
                  <p>
                     If you believe your copyrighted work has been infringed, please notify Towing 411 using the following contact details:
                  </p>
                  <ul>
                     <li><strong>Phone:</strong> +1 (800) 805-7820</li>
                     <li><strong>Email:</strong> contact@towing411.net</li>
                  </ul>

                  <h5>Legal Compliance</h5>
                  <p>
                     Users agree to comply with all applicable local, state, and federal laws while using the Service. Any activity that encourages or promotes illegal conduct is strictly prohibited.
                  </p>

                  <h5>Warranties Disclaimer</h5>
                  <p>
                     The Service is provided by Towing 411 on an "as is" and "as available" basis. We make no warranties or representations regarding the accuracy, reliability, or availability of Advertisers or services listed on the platform. Towing 411 disclaims all liability arising from use or inability to use the Service.
                  </p>

                  <h5>Limitation of Liability</h5>
                  <p>
                     To the fullest extent permitted by law, Towing 411 shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use of the Service. Some jurisdictions may not allow certain limitations, so portions of this section may not apply to all users.
                  </p>

                  <h6>Indemnification</h6>
                  <p>
                     You agree to indemnify, defend, and hold harmless Towing 411, its affiliates, officers, partners, and employees from any claims, damages, or expenses arising from your use of the Service or violation of these Terms.
                  </p>

                  <h6>General Terms</h6>
                  <p>
                     These Terms shall be governed by and construed in accordance with the laws of the State of Illinois. Any disputes shall be resolved exclusively in the courts located in DuPage County, Illinois. Any claim must be brought within one (1) year from the date the issue arose. If any provision of these Terms is found unenforceable, the remaining provisions shall remain in full force and effect.
                  </p>

                  <h6>Points System</h6>

                  <p className="mb-1"><strong>Earning Points</strong></p>
                  <ul>
                     <li>Users may earn points by uploading eligible service invoices, including towing, roadside assistance, and truck repair bills.</li>
                     <li>Every 100 Coins earned is equivalent to $10 in rewards.</li>
                  </ul>

                  <p className="mb-1"><strong>Redeeming Points</strong></p>
                  <ul>
                     <li>Points can be redeemed once a minimum balance of $100 (1,000 Coins) is reached.</li>
                     <li>Approved redemptions are credited to the user’s account using the available payout method.</li>
                  </ul>

                  <p className="mb-1"><strong>Minimum Balance Requirement</strong></p>
                  <ul>
                     <li>A minimum balance of $10 (100 Coins) must be maintained at all times.</li>
                     <li>Redemption requests that reduce the balance below this amount will not be processed.</li>
                  </ul>

                  <p className="mb-1"><strong>Fraud & Abuse</strong></p>
                  <ul>
                     <li>Any fraudulent activity, including submission of false invoices or manipulation of the rewards system, will result in immediate account suspension and forfeiture of accumulated points.</li>
                  </ul>

                  <p className="mb-1"><strong>Modification of Terms</strong></p>
                  <ul>
                     <li>Towing 411 reserves the right to modify, suspend, or discontinue the points system at any time without prior notice.</li>
                  </ul>

                  <p className="mb-1"><strong>Disputes & Final Decision</strong></p>
                  <ul>
                     <li>All disputes related to point accumulation or redemption shall be resolved at the sole discretion of Towing 411, and such decisions shall be final.</li>
                  </ul>

               </div>

            </div>
         </div>
      </section>
   </>
   );
};

export default TermsAndCondition;